/*eslint-disable react/no-set-state*/
import React, {PropTypes} from 'react';
import IdleTimer from 'react-idle-timer';
import {connect} from 'react-redux';
import SessionModal from './SessionModal';
import {bindActionCreators} from 'redux';
import SessionStorageService from '../../services/sessionStorage/sessionStorageService';
import '../../styles/modals/sessionModal.css';
import * as pathConstants from '../../constants/pathConstants';
import * as loginActions from '../../actions/loginActions';
class SessionTimer extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      /* timeout has to be in milliseconds */
      timeout: 1200000,
      remaining: null,
      myTimer: '',
      isIdle: false,
      showExtendModal: false,
      lastActive: null,
      elapsed: null
    };

    this.isIdle = this.isIdle.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this.reset = this.reset.bind(this);
    this.extendSession = this.extendSession.bind(this);
  }
  componentWillUnMount() {
    clearInterval(this.state.myTimer);
    this.reset();
  }
  isIdle() {
    this.setState({showExtendModal: true});
    this.refs.idleTimer.pause();
    let myTimer;
    if (this.state.showExtendModal === true) {
      myTimer = setInterval(() => {
        this.hideModal();
      }, 600000);
      this.setState({myTimer: myTimer});
    }
  }
  hideModal() {
    this.setState({showExtendModal: false});
    SessionStorageService.deleteItem('lastLogin');
    this.props.loginActions.logout(this.props.user);
    const logouturl = window.location.origin+pathConstants.pathToLogout;
    window.location = logouturl;
    clearInterval(this.state.myTimer);
  }
  extendSession(event) {
    event.preventDefault();
    this.setState({showExtendModal: false});
    clearInterval(this.state.myTimer);
    this.reset();
  }
  reset() {
    this.refs.idleTimer.reset();
  }
  render() {
    let timerDiv;
    if (this.props.authenticated) {
      timerDiv = (
        <div className="timer-container" hidden={!this.props.authenticated}>
          <div className="idleContainer">
            <IdleTimer
              ref="idleTimer"
              element={document}
              idleAction={this.isIdle}
              activeAction={this.isActive}
              timeout={this.state.timeout}/>
          </div>
          <div className="sessionModal">
            <SessionModal
              showExtendModal={this.state.showExtendModal}
              extendSession={this.extendSession}
              message="You have been inactive for 20 minutes. Your session will end in 10 minutes and you will be redirected to the Login page. If your session ends, any unsaved data will be lost. If you would like to continue your current session, please click Ok and continue using the application."/>
          </div>
        </div>
      );
    }
    return (
      <div className="timer-container">
        {timerDiv}
      </div>
    );
  }
}

SessionTimer.propTypes = {
  loginActions: PropTypes.object.isRequired,
  user: PropTypes.object,
  authenticated: PropTypes.bool
};

function mapStateToProps(state, ownProps) {
  const authenticated = ownProps.authenticated;
  const user = state.user[state.user.length - 1];
  return {user, authenticated};
}
function mapDispatchToProps(dispatch) {
  return {
    loginActions: bindActionCreators(loginActions, dispatch)
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(SessionTimer);


/** WEBPACK FOOTER **
 ** ./src/components/common/SessionTimer.js
 **/